import { $_app_server } from '@/_helpers'

export const distribService = {
  newListCase,
  distributionCase,
  getDistribListCase,
  getJudgesByCaseType,
  clearDistrib,
  setJudgeByCase,
  getStatJudgeCategory,
  getStatJudgeFullcount,
  referralOfCases,
  getCourtAlias,
  distributionHistory,
  getExcel
}

// список не распеределнных всех
function newListCase () { 
  return $_app_server.get('/distrib/new/' + getCourtAlias()).then(response => response.data)
}

// пусто или caseIds - список id дел на распредедление или categoryIds - список id категорий на рспредедение
function distributionCase (obj) {
  return $_app_server.post('/distrib/distrib/' + getCourtAlias(), obj).then(response => response.data)
}

// очистка дел распределенных на за эти даты
function clearDistrib (sDate, eDate) {
  return $_app_server.get('/distrib/clear/' + getCourtAlias() + "/" + sDate + '/' + eDate).then(response => response.data)
}

// список распределенных дел на период
function getDistribListCase (sDate, eDate) {
  return $_app_server.get('/distrib/list/' + getCourtAlias() + "/"  + sDate + '/' + eDate).then(response => response.data)
}

function distributionHistory (sDate, eDate) {
  return $_app_server.post('/distrib/history/' + getCourtAlias() + "/"  + sDate + '/' + eDate).then(response => response.data)
}

// получение списка судей нужного типа
function getJudgesByCaseType (casetype) {
  return $_app_server.get('/distrib/judges/' + getCourtAlias() + "/"  + casetype).then(response => response.data)
}


function getExcel (cases) {
  console.log(cases)
  return $_app_server.post('/downloadExcel', cases).then(response => response.data)
}

// установление судьи на дело
function setJudgeByCase (caseId, judgeId) {
  return $_app_server.put('/distrib/set/' + getCourtAlias() + "/"  + caseId + '/' + judgeId).then(response => response.data)
}

// полная статистика судья категория
function getStatJudgeCategory (sDate, eDate) { 
  return $_app_server.get('/distrib/category/' + getCourtAlias()+ "/" + sDate + '/' + eDate).then(response => response.data)
}

// статистика по распределению дел за период (чисто цифры)
function getStatJudgeFullcount (sDate, eDate) {
  return $_app_server.get('/distrib/stat/' + getCourtAlias() + "/" + sDate + '/' + eDate).then(response => response.data)
}

// передача дела другому судье
function referralOfCases (caseId, judgeId) {
  return $_app_server.get('/distrib/set/' + caseId + '/' + judgeId).then(response => response.data)
}

function getCourtAlias () {
  return localStorage.getItem("courtAlias")
}

